export enum sitToken{
  OP = "TOKEN OPERATIVO",
  AS = "ASIGNADO PARA INSTALACION",
  AC = "Active",
  CA = "CANCELADO",
  RI = "SE REQUIERE REINSTALACION",
  BL = "BLOQUEADO",
  BI = "ESTADO INVALIDO",
  SYNC_TOKEN = 'SYNC_TOKEN'
}
